import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

/* ── SVG illustrations for each medallion ─────────────────────── */

const HeritageArt = () => (
  <svg viewBox="0 0 160 160" width="100%" height="100%" aria-hidden="true">
    <defs>
      <linearGradient id="hf-sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#3a78c4" />
        <stop offset="100%" stopColor="#9ec5f5" />
      </linearGradient>
      <linearGradient id="hf-dome" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#f0c560" />
        <stop offset="100%" stopColor="#b8860b" />
      </linearGradient>
    </defs>
    <circle cx="80" cy="80" r="80" fill="url(#hf-sky)" />
    {/* stars */}
    <circle cx="32" cy="36" r="1.6" fill="#fff8e6" opacity="0.85" />
    <circle cx="120" cy="28" r="1.2" fill="#fff8e6" opacity="0.7" />
    <circle cx="140" cy="58" r="1.6" fill="#fff8e6" opacity="0.8" />
    <circle cx="22" cy="64" r="1" fill="#fff8e6" opacity="0.6" />
    {/* crescent moon */}
    <g transform="translate(122 32)">
      <circle cx="0" cy="0" r="9" fill="#fff8e6" />
      <circle cx="3.2" cy="-1.5" r="8" fill="url(#hf-sky)" />
    </g>
    {/* mosque silhouette */}
    <g transform="translate(40 80)">
      {/* main dome */}
      <path d="M40 30 q-22 0 -22 -22 q0 -22 22 -22 q22 0 22 22 q0 22 -22 22z" fill="url(#hf-dome)" />
      <rect x="38" y="-22" width="4" height="-10" fill="url(#hf-dome)" />
      <circle cx="40" cy="-32" r="2.4" fill="#f0c560" />
      {/* base */}
      <rect x="6" y="14" width="68" height="38" rx="2" fill="#f5e6c8" />
      <rect x="22" y="22" width="10" height="20" rx="5" fill="#3a2a12" />
      <rect x="48" y="22" width="10" height="20" rx="5" fill="#3a2a12" />
      <rect x="36" y="14" width="8" height="14" rx="4" fill="#3a2a12" />
      {/* minarets */}
      <rect x="-2" y="-6" width="6" height="58" fill="#f5e6c8" />
      <circle cx="1" cy="-10" r="5" fill="url(#hf-dome)" />
      <rect x="76" y="-6" width="6" height="58" fill="#f5e6c8" />
      <circle cx="79" cy="-10" r="5" fill="url(#hf-dome)" />
    </g>
  </svg>
);

const ListenArt = () => (
  <svg viewBox="0 0 160 160" width="100%" height="100%" aria-hidden="true">
    <defs>
      <linearGradient id="hf-listen-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#9466c4" />
        <stop offset="100%" stopColor="#d3b3ff" />
      </linearGradient>
      <linearGradient id="hf-page" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#fff8e6" />
        <stop offset="100%" stopColor="#f0e0b8" />
      </linearGradient>
    </defs>
    <circle cx="80" cy="80" r="80" fill="url(#hf-listen-bg)" />
    {/* musical notes */}
    <g fill="#fff8e6" opacity="0.85">
      <circle cx="118" cy="50" r="3.2" />
      <rect x="120" y="34" width="1.6" height="18" />
      <circle cx="34" cy="118" r="2.8" />
      <rect x="36" y="104" width="1.4" height="16" />
      <circle cx="44" cy="46" r="2.2" />
    </g>
    {/* open book */}
    <g transform="translate(40 60)">
      <path d="M0 8 q12 -8 32 -4 v50 q-20 -4 -32 4z" fill="url(#hf-page)" stroke="#3a2a12" strokeWidth="1.2" />
      <path d="M80 8 q-12 -8 -32 -4 v50 q20 -4 32 4z" fill="url(#hf-page)" stroke="#3a2a12" strokeWidth="1.2" />
      <line x1="40" y1="4" x2="40" y2="58" stroke="#3a2a12" strokeWidth="1.2" />
      {/* text lines */}
      <g stroke="#8a5f07" strokeWidth="1.4" strokeLinecap="round" opacity="0.7">
        <line x1="6"  y1="20" x2="32" y2="16.5" />
        <line x1="6"  y1="28" x2="32" y2="24.5" />
        <line x1="6"  y1="36" x2="28" y2="33" />
        <line x1="48" y1="16.5" x2="74" y2="20" />
        <line x1="48" y1="24.5" x2="74" y2="28" />
        <line x1="48" y1="33" x2="70" y2="36" />
      </g>
    </g>
    {/* headphones */}
    <g transform="translate(80 78)" fill="none" stroke="#fff8e6" strokeWidth="3.2" strokeLinecap="round">
      <path d="M-32 4 a32 32 0 0 1 64 0" />
    </g>
    <g transform="translate(80 78)" fill="#fff8e6">
      <rect x="-36" y="2" width="10" height="18" rx="3" />
      <rect x="26"  y="2" width="10" height="18" rx="3" />
    </g>
  </svg>
);

const SparkArt = () => (
  <svg viewBox="0 0 160 160" width="100%" height="100%" aria-hidden="true">
    <defs>
      <radialGradient id="hf-spark-bg" cx="0.5" cy="0.5" r="0.7">
        <stop offset="0%" stopColor="#ffb19a" />
        <stop offset="100%" stopColor="#c75d3a" />
      </radialGradient>
      <linearGradient id="hf-heart" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#fff" />
        <stop offset="100%" stopColor="#ffd3c2" />
      </linearGradient>
    </defs>
    <circle cx="80" cy="80" r="80" fill="url(#hf-spark-bg)" />
    {/* decorative sparkles */}
    <g fill="#fff8e6">
      <path d="M30 50 l2 5 l5 2 l-5 2 l-2 5 l-2 -5 l-5 -2 l5 -2z" opacity="0.85" />
      <path d="M128 38 l1.6 4 l4 1.6 l-4 1.6 l-1.6 4 l-1.6 -4 l-4 -1.6 l4 -1.6z" opacity="0.75" />
      <path d="M132 110 l2 5 l5 2 l-5 2 l-2 5 l-2 -5 l-5 -2 l5 -2z" opacity="0.85" />
      <path d="M28 116 l1.4 3.6 l3.6 1.4 l-3.6 1.4 l-1.4 3.6 l-1.4 -3.6 l-3.6 -1.4 l3.6 -1.4z" opacity="0.7" />
    </g>
    {/* book */}
    <g transform="translate(40 64)">
      <rect x="0" y="0" width="80" height="58" rx="6" fill="#fff8e6" stroke="#3a2a12" strokeWidth="1.4" />
      <line x1="40" y1="0" x2="40" y2="58" stroke="#3a2a12" strokeWidth="1.4" />
      <g stroke="#8a5f07" strokeWidth="1.2" strokeLinecap="round" opacity="0.5">
        <line x1="8"  y1="14" x2="32" y2="14" />
        <line x1="8"  y1="22" x2="32" y2="22" />
        <line x1="8"  y1="30" x2="28" y2="30" />
        <line x1="48" y1="14" x2="72" y2="14" />
        <line x1="48" y1="22" x2="72" y2="22" />
        <line x1="48" y1="30" x2="68" y2="30" />
      </g>
    </g>
    {/* heart floating above */}
    <g transform="translate(80 50)">
      <path
        d="M0 12 c-9 -9 -22 0 -16 10 c4 6 16 14 16 14 s12 -8 16 -14 c6 -10 -7 -19 -16 -10z"
        fill="url(#hf-heart)"
        stroke="#3a2a12"
        strokeWidth="1.2"
      />
    </g>
  </svg>
);

const FEATURES = [
  {
    id: 'library',
    number: 1,
    accent: 'coral',
    art: <SparkArt />,
    title: 'A whole library ready to read today',
    body: "Open the door to a world of books your child can dive into straight away — a growing library of stories, poems, history, non-fiction, seerah and Qur’anic stories, all in one place. With quizzes, favourites, playlists and reading progress, DeenLit makes building a reading journey fun, rewarding and easy to return to — one book at a time.",
    cta: { label: 'Browse the library', to: '/category/all' },
  },
  {
    id: 'ethos',
    number: 2,
    accent: 'sapphire',
    art: <HeritageArt />,
    title: 'Books with Islamic ethos and learning',
    body: "Stories, poems, history and non-fiction chosen with Islamic values in mind — books that encourage good character, kindness, honesty, courage, patience and a love of learning. Alongside, your child can explore the Prophets, the Sahabah, seerah, Qur’anic stories and inspiring moments from Muslim history — a safer space to enjoy reading and build their Islamic identity.",
    cta: { label: 'Explore Islam', to: '/category/islam' },
  },
  {
    id: 'listen',
    number: 3,
    accent: 'violet',
    art: <ListenArt />,
    title: 'Read, listen, and learn in Arabic and English',
    body: "Watch your child grow in confidence as they read and listen in both English and Arabic. Many books include narrated audio with synchronised word highlighting — helping them follow along, hear how words sound and understand their meaning. Whether building Arabic, improving English or relaxing with a bedtime story, language learning feels natural and enjoyable.",
    cta: { label: 'Listen now', to: '/category/all' },
  },
];

export default function HomeFeatures() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.18 }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`home-features ${visible ? 'is-visible' : ''}`}
      aria-label="Why Deenlit"
    >
      <div className="home-features-head">
        <div className="home-features-eyebrow">
          <span className="home-features-ornament">&#10040;</span>
          Why kids love it
          <span className="home-features-ornament">&#10040;</span>
        </div>
        <h2 className="home-features-title">A library built to inspire</h2>
        <p className="home-features-sub">
          Three reasons families return to Deenlit again and again.
        </p>
      </div>

      <div className="home-features-grid">
        {FEATURES.map((f, i) => (
          <article
            key={f.id}
            className={`home-feature-card a-${f.accent}`}
            style={{ '--feature-delay': `${0.15 * i}s` }}
          >
            <span className="home-feature-number" aria-hidden="true">{f.number}</span>
            <div className="home-feature-medallion">
              <div className="home-feature-medallion-ring" aria-hidden="true" />
              <div className="home-feature-medallion-orbit" aria-hidden="true">
                <span /><span /><span />
              </div>
              <div className="home-feature-medallion-art">{f.art}</div>
            </div>
            <h3 className="home-feature-title">{f.title}</h3>
            <p className="home-feature-body">{f.body}</p>
            <Link to={f.cta.to} className="home-feature-cta">
              {f.cta.label}
              <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 6 15 12 9 18" />
              </svg>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}
